import { ListOfficerFacade } from '@shared/feature/list-officer';
import { AgencyDetailsFacade } from '@shared/feature/agency-details';
import { AfterViewInit, Component, ContentChild, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { AppConfig } from '@shared/utils/app-config';
import { MenuItemsService } from '@shared/utils/menu-items';
import { PreviewUserHeadingServiceBase } from '../../services/preview-user-heading/preview-user-heading.service';
import { BaseAuthService } from '@shared/utils/base-auth';
import { filter, takeUntil } from 'rxjs';
import { NavbarComponent } from '@shared/ui/navbars';
import { NavigationEnd, Router } from '@angular/router';
import { LayoutSharedComponent } from '../layout-shared/layout-shared.component';

@Component({
    selector: 'feature-page-layout-layout-one',
    templateUrl: './layout-one.component.html',
    styleUrls: ['./layout-one.component.css'],
    standalone: false
})
export class LayoutOneComponent extends LayoutSharedComponent implements OnInit, AfterViewInit, OnDestroy {
  @ContentChild(TemplateRef) template!: TemplateRef<unknown>;
  @ViewChild(NavbarComponent) navbar?: NavbarComponent;

  constructor(
    public menuService: MenuItemsService,
    public authService: BaseAuthService,
    private appConfig: AppConfig,
    private listOfficerFacade: ListOfficerFacade,
    private agencyDetailsFacade: AgencyDetailsFacade,
    private router: Router,
    user: PreviewUserHeadingServiceBase,
    renderer: Renderer2
  ) {
    super(user, renderer);
  }

  ngOnInit(): void {
    this.menuService
      .getMenuItems()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((x) => {
        this.menuItems = x;
        this.isLoading = false;
      });

    if (this.favIcon) {
      this.favIcon.href = this.appConfig.statics.favicon;
    }
    this.listOfficerFacade.listOfficer();
    this.agencyDetailsFacade.fetchAgencyCategories();
    this.agencyDetailsFacade.fetchAgencySettings();

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((event: NavigationEnd) => {
        const isFullScreenParam = this.router.parseUrl(event.url).queryParams['isFullScreen'];
        this.isFullScreen = isFullScreenParam === 'True';
        if (!this.isFullScreen) {
          this.setActiveMenuItem();
        }
      });

    const isFullScreenParam = this.router.parseUrl(this.router.url).queryParams['isFullScreen'];
    const isCurrentUrlMatchingPattern = this.URL_PATTERN.test(this.router.url);
    if (isCurrentUrlMatchingPattern && isFullScreenParam === 'True') {
      this.isFullScreen = true;
    }
  }

  ngAfterViewInit(): void {
    this.setActiveMenuItem();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  private setActiveMenuItem(): void {
    const interval = setInterval(() => {
      if (this.navbar && this.menuItems && this.menuItems.length > 0) {
        this.navbar.setActiveMenuItem();
        clearInterval(interval);
      }
    }, 0);
  }
}
